import React from "react";
import { PricingTier } from "../../../../constants/PricingConstants";

const SEAT_TIER_LEGENDS = [
  {
    className: "sprite-seating-seat-curr-avail",
    pricingTier: PricingTier.Standard,
  },
  {
    className: "sprite-seating-seat-recliner",
    pricingTier: PricingTier.Recliner,
  },
  {
    className: "sprite-seating-seat-sofa",
    pricingTier: PricingTier.Sofa,
  },
  {
    className: "sprite-seating-seat-couple",
    pricingTier: PricingTier.Couple,
  },
  {
    className: "sprite-seating-seat-grand-recliner",
    pricingTier: PricingTier.GrandRecliner,
  },
];

const SEAT_STATUS = [
  {
    label: "Available",
    className: "sprite-seating-seat-curr-avail",
  },
  {
    label: "Selected",
    className: "sprite-seating-seat-curr-select",
  },
  {
    label: "Unavailable",
    className: "sprite-seating-seat-curr-unavail",
  },
  {
    label: "Onhold",
    className: "sprite-seating-seat-curr-hold",
  },
  {
    label: "Wheelchair",
    className: "sprite-seating-seat-curr-wheelchair-avail",
  },
];
export const SeatSelectionLegend = (props) => {
  const availableTiers = SEAT_TIER_LEGENDS.filter((tier) =>
    props.performanceTicketTypes.some(
      (type) => type.pricingTier === tier.pricingTier
    )
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px 32px",
        flexWrap: "wrap",
      }}
    >
      {SEAT_STATUS.map((x) => (
        <div key={x.label} className="d-flex align-items-center">
          <div className={x.className} />
          {x.label}
        </div>
      ))}
      {availableTiers.map((tier) => (
        <div
          style={{ gap: "4px" }}
          className="d-flex align-items-center"
          key={tier.pricingTier}
        >
          <div className={tier.className}></div>{" "}
          <span className="text-nowrap">
            {PricingTier.getName(tier.pricingTier, {
              locationVenueBrand: props.locationVenueBrand,
            })}
          </span>
        </div>
      ))}
    </div>
  );
};
